import { NavigateOptions } from 'next/dist/shared/lib/app-router-context.shared-runtime'
import { useMemo } from 'react'
import { Locale } from '@/setup/locales'
import { ILinkParams, IUrlPattern, useRawNextIntlRouter } from '../routing'

type IRouterNavigate = <T extends IUrlPattern>(
    params: ILinkParams<T>,
    options?: NavigateOptions & { locale?: Locale }
) => void

export type IRouterPush = IRouterNavigate
export type IRouterReplace = IRouterNavigate

type IRouter = Omit<ReturnType<typeof useRawNextIntlRouter>, 'push' | 'replace'> & {
    push: IRouterPush
    replace: IRouterReplace
}

export const useRouter = () => {
    const nextIntlRouter = useRawNextIntlRouter()

    return useMemo((): IRouter => {
        return {
            back: nextIntlRouter.back,
            forward: nextIntlRouter.forward,
            prefetch: nextIntlRouter.prefetch,
            refresh: nextIntlRouter.refresh,

            push: (params, options) => {
                // biome-ignore lint/suspicious/noExplicitAny: biome migration
                const routerPushParams: any = {
                    pathname: params.pattern,
                    params: params.params,
                }

                return nextIntlRouter.push(routerPushParams, options)
            },

            replace: (params, options) => {
                // biome-ignore lint/suspicious/noExplicitAny: biome migration
                const routerReplaceParams: any = {
                    pathname: params.pattern,
                    params: params.params,
                }

                return nextIntlRouter.replace(routerReplaceParams, options)
            },
        }
    }, [nextIntlRouter])
}
